import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { DatePicker } from 'antd'
import Skeleton from 'react-loading-skeleton'

import { useAppSelector } from '@/store/hook'
import { selectDateFormat } from '@/store/selectors/configSelector'
import { dateUtils, dayjs } from '@/libs/utils/dateUtils'

import styles from './DatePeriod.module.scss'

const { RangePicker } = DatePicker

const disableDate = (current) => {
  return dateUtils.isAfterToday(current)
}

const RenderDatePeriod = memo(({ from, to, onDateChange }) => {
  const dateFormat = useAppSelector(selectDateFormat)
  if (!dateFormat) {
    return <Skeleton style={{ height: 42, width: 280 }} />
  }

  return (
    <RangePicker
      className={styles.picker}
      defaultValue={from && to ? [dayjs(from), dayjs(to)] : [null, null]}
      disabledDate={disableDate}
      format={dateFormat}
      getPopupContainer={(trigger) => trigger}
      placeholder={[dateFormat, dateFormat]}
      popupClassName={styles.dropdown}
      separator="|"
      size="large"
      onChange={onDateChange}
    />
  )
})

export const DatePeriod = (props) => {
  const { t } = useTranslation()

  return (
    <div>
      <span className={styles.title}>{t('filter.datePeriod')}</span>
      <div className={styles.datePeriodWrapper}>
        <RenderDatePeriod {...props} />
      </div>
    </div>
  )
}
